import React, { useMemo } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from '@material-ui/core';
import moment from 'moment';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import { WrapperTabela } from './styles';

export default function TablePitStopFatorConsumo({
  rows,
  agrupamento,
  agrupaPorDia,
}) {
  const exibeData = Number(agrupaPorDia) === 1;
  const formataVolume = (value) => (Number(value) === 0 ? '' : number(value, 2));
  const totalizadores = useMemo(() => {
    const totais = rows.reduce(
      (acc, row) => ({
        volumemovimentacaoabastecimento:
          acc.volumemovimentacaoabastecimento +
          Number(row.volumemovimentacaoabastecimento || 0),
        volumemovimentacaolubrificacao:
          acc.volumemovimentacaolubrificacao +
          Number(row.volumemovimentacaolubrificacao || 0),
      }),
      {
        volumemovimentacaoabastecimento: 0,
        volumemovimentacaolubrificacao: 0,
      }
    );

    return {
      ...totais,
      fatorconsumo:
        totais.volumemovimentacaoabastecimento === 0
          ? 0
          : totais.volumemovimentacaolubrificacao /
          totais.volumemovimentacaoabastecimento * 100,
    };
  }, [rows]);

  const headers = useMemo(() => {
    const items = [];

    if (exibeData) {
      items.push(t('s.relatorio.afericao.data'));
    }

    if (agrupamento === 'L') {
      items.push(t('s.menu.cadastro.veiculo.locomotiva'));
    }

    items.push(
      t('s.menu.cadastro.veiculo.modelo'),
      t('s.relatorio.pitstopfatorconsumo.quantidadecombustivel'),
      t('s.relatorio.pitstopfatorconsumo.quantidadelubrificante'),
      t('s.menu.relatorio.relpitstopfatorconsumo') + " (%)"
    );

    return items;
  }, [agrupamento, exibeData]);

  return (
    <WrapperTabela height="80vh">
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell align="center" key={`cell-index-head-${index}`}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow hover tabIndex={-1} key={`table-row-body-${index}`}>
                {exibeData && (
                  <TableCell key="table-cell-body-1" align="center">
                    {row.data ? moment(row.data).format('DD/MM/YYYY') : ''}
                  </TableCell>
                )}

                {agrupamento === 'L' && (
                  <TableCell key="table-cell-body-2">
                    {row.idveiculo}
                  </TableCell>
                )}

                <TableCell key="table-cell-body-3">
                  {row.nomemodeloveiculoabastecimento}
                </TableCell>
                <TableCell key="table-cell-body-4" align="right">
                  {formataVolume(row.volumemovimentacaoabastecimento)}
                </TableCell>
                <TableCell key="table-cell-body-5" align="right">
                  {formataVolume(row.volumemovimentacaolubrificacao)}
                </TableCell>
                <TableCell key="table-cell-body-6" align="right">
                  {number(row.fatorconsumo, 4)}
                </TableCell>
              </TableRow>
            ))}
            {rows.length > 0 && (
              <TableRow hover tabIndex={-1} key="table-row-total">
                <TableCell>
                  <strong>{t('s.geral.total')}</strong>
                </TableCell>

                {exibeData && <TableCell />}

                {agrupamento === 'L' && <TableCell />}

                <TableCell align="right">
                  <strong>
                    {formataVolume(
                      totalizadores.volumemovimentacaoabastecimento
                    )}
                  </strong>
                </TableCell>
                <TableCell align="right">
                  <strong>
                    {formataVolume(
                      totalizadores.volumemovimentacaolubrificacao
                    )}
                  </strong>
                </TableCell>
                <TableCell align="right">
                  <strong>{number(totalizadores.fatorconsumo, 4)}</strong>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={headers.length} align="right">
                <strong>
                  {t('s.relatorio.geral.totalregistros')}: {rows.length}
                </strong>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </WrapperTabela>
  );
}

TablePitStopFatorConsumo.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  agrupamento: PropTypes.string.isRequired,
  agrupaPorDia: PropTypes.number.isRequired,
};
